import request from '@utils/request';

const v1Url = (path) => {
	return `${window.HOST}/mini_background/v1/${path}`;
};
const v2Url = (path) => {
	return `${window.HOST}/mini_background/v2/${path}`;
};

const newUrl = (path)=>{
	return `${window.NewHOST}/background/v2/${path}`
}

// 示例: 登录中获取验证码接口
const info_api = {
	// testUrl() {
	// 	// 获取passport中转地址
	// 	return request.get('');
	// },
	// uploadImage() {
	// 	const url = v1Url('file/upload');

	// 	return request.post(url, (params: {}), {
	// 		headers: { 'Content-Type': 'multipart/form-data' },
	// 	});
	// },
	// 提交审核
	toSubmit(params) {
		const url = newUrl('nonage-refunded');

		return request.post(url, { data: params });
	},
};

export default info_api;
